// Saves and the economy keep their integer accounting units. One old trading
// note is 100 silver coins; these names are presentation only.
export const SILVER_PER_NOTE = 100;
export const CURRENCY_HELP = 'Fictional trading notes and silver coins. 100 silver coins = 1 note. Nothing here spends real money.';

function amountParts(cents, signed) {
  const parsed = Number(cents || 0);
  const value = Number.isFinite(parsed) ? Math.round(parsed) : 0;
  const absolute = Math.abs(value);
  return {
    sign: value < 0 ? '−' : signed && value > 0 ? '+' : '',
    notes: Math.floor(absolute / SILVER_PER_NOTE),
    silver: absolute % SILVER_PER_NOTE,
  };
}

export function formatCurrency(cents, signed = false) {
  const { sign, notes, silver } = amountParts(cents, signed);
  const parts = [];
  if (notes || !silver) parts.push(`${notes.toLocaleString('en-US')} ${notes === 1 ? 'note' : 'notes'}`);
  if (silver) parts.push(`${silver} silver ${silver === 1 ? 'coin' : 'coins'}`);
  return `${sign}${parts.join(' · ')}`;
}

// Only use the abbreviated fractions beside a visible currency label.
export function compactCurrency(cents, signed = false) {
  const { sign, notes, silver } = amountParts(cents, signed);
  if (!silver) return formatCurrency(cents, signed);
  return `${sign}${notes ? `${notes.toLocaleString('en-US')} n · ` : ''}${silver} s`;
}

// Earlier saves can contain completed ledger descriptions and Poker action
// labels in dollars. Translate their display without rewriting saved balances.
export function formatCurrencyText(value) {
  return String(value).replace(/\$([\d,]+(?:\.\d{1,2})?)/g, (_, amount) => formatCurrency(Math.round(Number(amount.replaceAll(',', '')) * SILVER_PER_NOTE)));
}
